import React from 'react';
import {useInvalidFields} from '../../../data/hooks/requiredUserActions';
import InvalidFields from './InvalidFields/InvalidFields';
import LayoutColumns from '../LayoutColumns/LayoutColumns';

function RequiredUserActions(props) {
    const {} = props,
        invalidFields = useInvalidFields(),
        errorsToFix = invalidFields.length;

    if (!errorsToFix) return null;

    return (
        <LayoutColumns>
            <div className="alert alert-warning">
                <InvalidFields invalidFields={invalidFields} />
            </div>
        </LayoutColumns>
    );
}

export default RequiredUserActions;
